import React from 'react'
import Link from './Link'
import styledComponents from 'styled-components'

export default ({ path, title, children, className }) => (
  <Link to={path}>
    <CardLayout className={className}>
      {
        // <div className="card-image">
        //   <figure className="image is-4by3">
        //     <img
        //       src="https://bulma.io/images/placeholders/1280x960.png"
        //       alt="Placeholder"
        //     />
        //   </figure>
        // </div>
      }
      <div className="card-content">
        <div className="media">
          <p className="title is-4">{title}</p>
        </div>

        <div className="content has-text-grey">{children}</div>
      </div>
    </CardLayout>
  </Link>
)

const CardLayout = styledComponents.div.attrs({ className: 'card' })`
  min-height: 250px;
`



// WEBPACK FOOTER //
// ./src/components/views/buttons/MenuButton.js